<template lang="pug">
#pre-analise-credito
    BaseHeaderPreAnalise(
        :titulo="$t('mensagens.preAnaliseCredito.titulo')",
        icon='el-icon-plus',
        :exibeBotao='false',
        :totalizadores='totalizadoresConsultas',
        @abrirModalVistualizarTotalizadoresConsultas='abrirModalVistualizarTotalizadoresConsultas()'
    )

    .view-container-base-header
        span(
            style='font-size: 18px; margin-bottom: 15px; color: #2c2c2c; font-weight: 500; line-height: 18.75px'
        ) {{ $t('mensagens.preAnaliseCredito.paraRealizarNovaConsultaDigiteCpfCnpj') }}
        .pre-analise-credito-container
            .pre-analise-credito-input-container
                .pre-analise-creditoinput
                    i.el-icon-search
                    div(:class='!inputCpfCnpjValido && inputCpfCnpj.length > 13 ? "lista-pre-analise-creditobarra-pesquisainput-erro" : "lista-pre-analise-creditobarra-pesquisainput"')
                        el-input(
                            v-model='inputCpfCnpj',
                            type='text',
                            :placeholder="$t('mensagens.preAnaliseCredito.busquePorCpfCnpj')",
                            autocomplete='off',
                            clearable,
                            @clear='limparInputPesquisa',
                            @keyup.native.enter='onChangeSearchInput',
                            v-mask='["###.###.###-##", "##.###.###/####-##"]'
                        )

            .pre-analise-credito__pesquisa-button
                BaseButton.pre-analise-credito__btn-pesquisa(
                    type='primary',
                    :loading='isLoading',
                    :disabled='!inputCpfCnpjValido',
                    @click='onChangeSearchInput'
                )
                    | {{ $t('mensagens.comuns.pesquisar') }}
        div(:class='exibeErro ? "show-error-busca" : "hide-error-busca"')
        el-alert.mb-3.px-4(
            v-if='exibeErro',
            :title='getTitleWarningMessage()',
            type='error',
            :closable='true',
            show-icon,
            @close='closeMessage'
        )
        .invalido(v-show='$v.inputCpfCnpj.$invalid')
        .invalido(
            :style='!inputCpfCnpjValido && inputCpfCnpj.length > 13 ? "opacity: 1; margin-bottom: 8px" : "opacity: 0; margin-bottom: 8px"'
        ) &nbsp;CPF/CNPJ inválido

        span(
            style='font-size: 16px; margin-bottom: 15px; color: #2c2c2c; font-weight: 500; line-height: 18.75px'
        ) {{ efetuouPesquisa && totalItems > 0 ? $t('mensagens.preAnaliseCredito.resultadoConsulta') : $t('mensagens.preAnaliseCredito.historicoConsulta') }}

        .tabela(v-if='totalItems > 0')
            el-table(
                :key="listagemTableKey('pre-analise', resultadosBusca, paginaAtual)",
                stripe,
                height='calc(100% - 57px)',
                :data='resultadosBusca',
                v-loading='isLoadingTable',
                :default-sort='{ prop: "dataConsulta", order: "descending" }',
                @sort-change='ordenar'
            )
                el-table-column(
                    :formatter='formatCpfCnpjTableColumn',
                    prop='numeroCpfCnpj',
                    label='CPF/CNPJ',
                    min-width='200'
                )
                el-table-column(prop='nomeCliente', :label="$t('mensagens.preAnaliseCredito.nome')", :formatter='formatNomeTableColumn' min-width='500', sortable)
                el-table-column(
                    prop='dataConsultaFormatada',
                    :label="$t('mensagens.preAnaliseCredito.dataConsulta')",
                    min-width='300',
                    sortable
                )
                el-table-column(min-width='100', align='center', :label="$t('mensagens.comuns.acoes')")
                    .template(slot-scope='scope')
                        el-dropdown.acoes(trigger='click')
                            span.el-dropdown-link
                                i.mdi.mdi-dots-vertical
                            el-dropdown-menu(slot='dropdown')
                                el-dropdown-item(
                                    icon='el-icon-view',
                                    @click.native='visualizar(scope.row)'
                                ) {{ $t('mensagens.comuns.visualizar') }}
                                el-dropdown-item(
                                    icon='mdi mdi-check-underline',
                                    @click.native='marcarExportacaoAnaliseCreditoPdf(scope.row)'
                                ) {{ $t('mensagens.preAnaliseCredito.marcarParaExportacao') }}
            .py-3.btn-paginacao(
                v-if='totalItems > 0',
                style='text-align: center'
            )
                el-pagination(
                    background,
                    :page-size='itemsPorPagina',
                    :pager-count='7',
                    layout='prev, pager, next',
                    :total='totalItems',
                    @prev-click='voltarPagina',
                    @next-click='avancarPagina',
                    @current-change='atualizarPagina'
                )
        .tabela-pesquisa-sem-resultado(
            v-else
        )
            .d-flex.justify-content-center.align-items-center.w-100.my-3(style="height='calc(100% - 82px)")
                empty-result-analise(
                    :p1="$t('mensagens.preAnaliseCredito.voceNaoTemConsultasParaSeremExibidas')",
                    :p2="$t('mensagens.preAnaliseCredito.facaUmaPrimeiraBusca')",
                    :efetuouPesquisa='efetuouPesquisa'
                )
    BaseModalGeral(
        v-if='modalVisualizarConsulta',
        :show='modalVisualizarConsulta',
        :title="$t('mensagens.preAnaliseCredito.visualizarConsulta')",
        :mostrar-botao-confirmar='true',
        width='600px',
        @closeDialog='modalVisualizarConsulta = false;'
        @confirmDialog='visualizarHistorico()'
    )
        div.modal-info-text
            div.alert-box
                div.alert-icon
                    | !
                p.bold-text {{ $t('mensagens.preAnaliseCredito.atencao') }}.

            p.no-break {{ $t('mensagens.preAnaliseCredito.consultaRealizadaNoDia') }} {{ dataConsultaVisualizada }}, {{ $t('mensagens.preAnaliseCredito.voceIraVisualizarReferenteAEssaData') }}.

            p.no-break {{ $t('mensagens.preAnaliseCredito.paraVisualizarDadosAtualizadosDeste') }} {{ tipoDocumento }},  {{ $t('mensagens.preAnaliseCredito.porFavorRealizeNovaBusca') }}.

            p.bold-text {{ $t('mensagens.preAnaliseCredito.desejaContinuarComConsultaDoDia') }} {{ dataConsultaVisualizada }}?
    BaseModalVisualizarExtratoConsultas(
        :show='modalVisualizarExtratoConsultas',
        :title="$t('mensagens.preAnaliseCredito.extratoDeConsultas')",
        :mostrar-botao-fechar='true',
        :isLoading="isLoadingModalExtrato"
        :totalizadores='resultadoExtratoConsulta',
        width='750px',
        @closeDialog='modalVisualizarExtratoConsultas = false;',
        @mudarTipoConsulta='mudarTipoConsulta',
        @mudarMesVigenteConsulta='mudarMesVigenteConsulta'
    )
</template>

<script>
import BaseHeaderPreAnalise from '../components/BaseHeaderPreAnalise.vue';
import EmptyResultAnalise from '../components/EmptyResultAnalise';
import BaseModalGeral from '../components/BaseModalGeral.vue';
import BaseModalVisualizarExtratoConsultas from '../components/BaseModalVisualizarExtratoConsultas.vue';
import BaseButton from '../components/BaseButton.vue';

import validators from '@/utils/validations/validators';
import formatters from '../utils/formatters';

import { required } from 'vuelidate/lib/validators';

import PreAnaliseService from '../services/PreAnaliseCredito';

import preAnaliseServiceMixin from '@/modules/pre-analise-credito/mixins/PreAnaliseCreditoMixin';

import store from '@/store';

import { mapActions } from 'vuex';

export default {
    name: 'PreAnaliseCredito',

    components: {
        BaseHeaderPreAnalise,
        EmptyResultAnalise,
        BaseModalGeral,
        BaseModalVisualizarExtratoConsultas,
        BaseButton
    },

    mixins: [preAnaliseServiceMixin],

    data() {
        return {
            inputCpfCnpj: '',
            efetuouPesquisa: false,
            dataConsultaVisualizada: null,
            modalVisualizarConsulta: false,
            tipoDocumento: '',
            resultadosBusca: [],
            resultadoHistorico: null,
            totalItems: 0,
            paginaAtual: 1,
            itemsPorPagina: 10,
            ordenacao: 'dataConsulta,desc',
            isLoading: false,
            exibeErro: false,
            isLoadingTable: false,
            totalizadoresConsultas: {
                totalConsultas: 0,
                totalConsultasNoMes: 0,
                totalCreditoConsumidoMes: 0
            },
            resultadoExtratoConsulta: {},
            isLoadingModalExtrato: false,
            modalVisualizarExtratoConsultas: false,
            tipoConsultaExtrato: 'TODOS',
            mesVigenteConsultaExtrato: this.mxGetMesAtual()
        };
    },

    validations: {
        inputCpfCnpj: {
            required
        }
    },

    computed: {
        inputCpfCnpjValido() {
            if (this.inputCpfCnpj) {
                return validators.validarDocumento(this.inputCpfCnpj);
            }

            return false;
        }
    },

    async created() {
        window.localStorage.removeItem('consultaNeoway');
        window.localStorage.removeItem('processos');
        this.clearStoredPageData();
        await this.buscarHistoricoDeBusca();
        store.dispatch('setResponsePreAnalisePF', null);

        if (this.$route.params.cpfCnpj) {
            let documento = this.$route.params.cpfCnpj;
            if (documento.length === 11 || documento.length === 14) {
                await this.processarBusca(documento);
            }
        }
    },

    methods: {
        ...mapActions(['setMarcarExportarNeoway_PDF']),
        onChangeSearchInput() {
            this.processarBusca(null);
        },

        clearStoredPageData() {
            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                if (key && key.startsWith('pageData_')) {
                    localStorage.removeItem(key);
                    i--;
                }
            }
        },

        formatarTextoBusca(inputCpfCnpj) {
            if (inputCpfCnpj) {
                return formatters.documentoFormatToNumeral(inputCpfCnpj);
            }
        },

        ordenar({ column, order }) {
            this.resultadosBusca = [];

            let nome = this.$t('mensagens.preAnaliseCredito.nome');
            let dataConsulta = this.$t(
                'mensagens.preAnaliseCredito.dataConsulta'
            );

            const nomesColunas = {
                'CPF/CNPJ': 'numeroCpfCnpj',
                [nome]: 'nomeCliente',
                [dataConsulta]: 'dataConsulta'
            };
            this.ordenacao = nomesColunas[column.label];

            let sentido = '';
            if (order === 'ascending') sentido = ',asc';
            if (order === 'descending') sentido = ',desc';
            if (order === null) sentido = ',desc';

            this.ordenacao += sentido;
            this.buscarHistoricoDeBusca();
        },

        async processarBusca(routeParamCpfCnpj) {
            if (this.inputCpfCnpj) {
                this.isLoading = true;
                this.exibeErro = false;
                const cpfCnpj = this.formatarTextoBusca(this.inputCpfCnpj);
                if (cpfCnpj.length === 11) {
                    try {
                        PreAnaliseService.pesquisaNeowayPF({
                            cpf: cpfCnpj
                        }).then(response => {
                            if (response.data !== '') {
                                window.localStorage.setItem(
                                    'consultaNeoway',
                                    JSON.stringify(response.data)
                                );
                                store.dispatch(
                                    'setResponsePreAnalisePF',
                                    response.data
                                );
                                this.$router.push({
                                    name: 'VisualizarPreAnaliseCredito',
                                    params: {
                                        cpfCnpj: cpfCnpj,
                                        id: response.data.idConsultaNeoway
                                    }
                                });
                                if (response.error) {
                                    this.isLoading = false;
                                }
                                this.isLoading = false;
                            } else {
                                this.isLoading = false;
                                this.exibeErro = true;
                            }
                        });
                    } catch (error) {
                        this.isLoading = false;
                        this.$notify.warning({
                            message: this.$t(
                                'mensagens.preAnaliseCredito.erro.busca'
                            )
                        });
                    }
                } else if (cpfCnpj.length === 14) {
                    try {
                        PreAnaliseService.pesquisaNeowayPJ({
                            cnpj: cpfCnpj
                        }).then(response => {
                            if (response.data !== '') {
                                if (response.data) {
                                    window.localStorage.setItem(
                                        'consultaNeoway',
                                        JSON.stringify(response.data)
                                    );
                                    store.dispatch(
                                        'setResponsePreAnalisePF',
                                        response.data
                                    );
                                    this.$router.push({
                                        name: 'VisualizarPreAnaliseCredito',
                                        params: {
                                            cpfCnpj: cpfCnpj,
                                            id: response.data.idConsultaNeoway
                                        }
                                    });
                                    if (response.error) {
                                        this.isLoading = false;
                                    }
                                    this.isLoading = false;
                                } else {
                                    this.isLoading = false;
                                    this.$notify.warning({
                                        message: this.$t(
                                            'mensagens.preAnaliseCredito.erro.busca'
                                        )
                                    });
                                }
                            } else {
                                this.isLoading = false;
                                this.exibeErro = true;
                            }
                        });
                    } catch (error) {
                        this.isLoading = false;
                        this.$notify.warning({
                            message: this.$t(
                                'mensagens.preAnaliseCredito.erro.busca'
                            )
                        });
                    }
                } else {
                    this.$notify.warning({
                        message: this.$t(
                            'mensagens.preAnaliseCredito.erro.digiteCpfCnpjValido'
                        )
                    });
                    this.isLoading = false;
                }
            } else if (routeParamCpfCnpj) {
                this.inputCpfCnpj =
                    this.numeralStringFormatToDocumento(routeParamCpfCnpj);
                this.isLoading = true;
                this.exibeErro = false;
                const cpfCnpj = this.formatarTextoBusca(routeParamCpfCnpj);
                if (cpfCnpj.length === 11) {
                    try {
                        PreAnaliseService.pesquisaNeowayPF({
                            cpf: cpfCnpj
                        }).then(response => {
                            if (
                                response.error ||
                                response.data === null ||
                                response.data === ''
                            ) {
                                this.isLoading = false;
                                this.exibeErro = true;
                            } else {
                                let objResponse = response.data;
                                if (this.$route.params.voltarSig === true) {
                                    objResponse.goBackSig = true;
                                } else {
                                    objResponse.goBackHomeDashboard = true;
                                }

                                window.localStorage.setItem(
                                    'consultaNeoway',
                                    JSON.stringify(objResponse)
                                );
                                store.dispatch(
                                    'setResponsePreAnalisePF',
                                    objResponse
                                );
                                this.$router.push({
                                    name: 'VisualizarPreAnaliseCredito',
                                    params: { cpfCnpj: cpfCnpj }
                                });
                                this.isLoading = false;
                            }
                        });
                    } catch (error) {
                        this.isLoading = false;
                        this.$notify.warning({
                            message: this.$t(
                                'mensagens.preAnaliseCredito.erro.busca'
                            )
                        });
                    }
                } else if (cpfCnpj.length === 14) {
                    try {
                        PreAnaliseService.pesquisaNeowayPJ({
                            cnpj: cpfCnpj
                        }).then(response => {
                            if (
                                response.error ||
                                response.data === null ||
                                response.data === ''
                            ) {
                                this.isLoading = false;
                                this.exibeErro = true;
                            } else {
                                let objResponse = response.data;
                                if (this.$route.params.voltarSig === true) {
                                    objResponse.goBackSig = true;
                                } else {
                                    objResponse.goBackHomeDashboard = true;
                                }
                                window.localStorage.setItem(
                                    'consultaNeoway',
                                    JSON.stringify(objResponse)
                                );
                                store.dispatch(
                                    'setResponsePreAnalisePF',
                                    objResponse
                                );
                                this.$router.push({
                                    name: 'VisualizarPreAnaliseCredito',
                                    params: { cpfCnpj: cpfCnpj }
                                });
                                this.isLoading = false;
                            }
                        });
                    } catch (error) {
                        this.isLoading = false;
                        this.$notify.warning({
                            message: this.$t(
                                'mensagens.preAnaliseCredito.erro.busca'
                            )
                        });
                    }
                } else {
                    this.$notify.warning({
                        message: this.$t(
                            'mensagens.preAnaliseCredito.erro.digiteCpfCnpjValido'
                        )
                    });
                    this.isLoading = false;
                }
            }
        },

        buscarHistoricoDeBusca() {
            this.isLoadingTable = true;
            try {
                PreAnaliseService.consultarHistoricoNeoway({
                    size: this.itemsPorPagina,
                    page: this.paginaAtual - 1,
                    ordenacao: this.ordenacao
                })
                    .then(response => {
                        this.resultadosBusca = response.data.itens;
                        this.totalItems = response.data.totalItens;
                        this.totalizadoresConsultas = {
                            totalConsultas: response.data.totalConsultas || 0,
                            totalConsultasNoMes:
                                response.data.totalConsultasNoMes || 0,
                            totalCreditoConsumidoMes:
                                response.data.totalCreditoConsumidoMes || 0
                        };

                        this.isLoadingTable = false;
                    })
                    .catch(() => {
                        this.$notify.warning({
                            message: this.$t(
                                'mensagens.preAnaliseCredito.erro.obterHistoricoDeBusca'
                            )
                        });
                        this.isLoadingTable = false;
                    });
            } catch (error) {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.preAnaliseCredito.erro.obterHistoricoDeBusca'
                    )
                });
                this.isLoading = false;
            }
        },

        limparInputPesquisa() {
            this.efetuouPesquisa = false;
        },

        getTitleWarningMessage() {
            return this.$t(
                'mensagens.preAnaliseCredito.erro.naoEncontramosRegistrosCpfCnpj'
            );
        },

        visualizar(row) {
            this.dataConsultaVisualizada = row.dataHoraConsultaFormatada;
            this.tipoDocumento = row.tipoConsulta;
            this.historicoSelecionado = row;
            this.modalVisualizarConsulta = true;
        },

        async visualizarHistorico() {
            const row = this.historicoSelecionado;
            this.modalVisualizarConsulta = false;
            let objConsulta = null;

            try {
                await PreAnaliseService.visualizarHistoricoNeoway({
                    idConsultaNeoway: row.id
                })
                    .then(response => {
                        objConsulta =
                            response.data.empresa ||
                            response.data.pessoa ||
                            null;
                    })
                    .catch(() => {
                        this.$notify.warning({
                            message: this.$t(
                                'mensagens.preAnaliseCredito.erro.obterHistoricoDeConsulta'
                            )
                        });
                    });
            } catch (error) {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.preAnaliseCredito.erro.obterHistoricoDeBusca'
                    )
                });
            }

            window.localStorage.setItem(
                'consultaNeoway',
                JSON.stringify(objConsulta)
            );
            store.dispatch('setResponsePreAnalisePF', objConsulta);
            this.$router.push({
                name: 'VisualizarPreAnaliseCredito',
                params: {
                    cpfCnpj: row.numeroCpfCnpj,
                    historico: this.dataConsultaVisualizada,
                    id: row.id
                }
            });
        },

        formatCpfCnpjTableColumn(row, column, cpfCnpj, index) {
            return formatters.numeralStringFormatToDocumento(cpfCnpj);
        },

        formatNomeTableColumn(row, column, nome, index) {
            return (
                this.mxNormalisarNomes(nome) ||
                this.$t('mensagens.preAnaliseCredito.erro.nomeNaoEncontrado')
            );
        },

        avancarPagina() {
            if (this.paginaAtual < this.totalPages) {
                this.paginaAtual++;
                this.buscarHistoricoDeBusca();
            }
        },
        voltarPagina() {
            if (this.paginaAtual > 1) {
                this.paginaAtual--;
                this.buscarHistoricoDeBusca();
            }
        },
        atualizarPagina(pagina) {
            this.paginaAtual = pagina;
            this.buscarHistoricoDeBusca();
        },

        closeMessage() {
            this.exibeErro = false;
        },

        numeralStringFormatToDocumento(cpfCnpj) {
            return formatters.numeralStringFormatToDocumento(cpfCnpj);
        },

        marcarExportacaoAnaliseCreditoPdf(row) {
            let nome = row.nomeCliente;

            const params = {
                idLista: Math.floor(Date.now() * Math.random()).toString(36),
                tipoDocumento: 'CPF_CNPJ',
                idConsulta: row.id,
                numeroCpfCnpj: row.numeroCpfCnpj,
                documento:
                    'CPF/CNPJ: ' +
                    this.numeralStringFormatToDocumento(row.numeroCpfCnpj),
                nome: 'Nome: ' + nome
            };

            this.setMarcarExportarNeoway_PDF(params);
        },

        async abrirModalVistualizarTotalizadoresConsultas() {
            this.mesVigenteConsultaExtrato = this.mxGetMesAtual();
            this.tipoConsultaExtrato = 'TODOS';
            this.modalVisualizarExtratoConsultas = true;
            this.isLoadingModalExtrato = true;
            await this.visualizarTotalizadorConsultasNeoway();
        },

        async visualizarTotalizadorConsultasNeoway() {
            let mesVigenteConsultaExtrato_ = this.tratarDataRequest(
                this.mesVigenteConsultaExtrato
            );
            try {
                await PreAnaliseService.visualizarTotalizadorConsultasNeoway(
                    this.tipoConsultaExtrato,
                    mesVigenteConsultaExtrato_
                )
                    .then(response => {
                        let dadosTabela = [];
                        const {
                            totalConsultas,
                            totalConsultasNoMes,
                            totalCreditoConsumidoMes,
                            primeiroRegistro,
                            datas
                        } = response.data;

                        if (datas || datas.length > 0) {
                            datas.map(item => {
                                let geral = item.detalhes.filter(
                                    item => item.tipo === 'Geral'
                                );
                                let processosJudiciais = item.detalhes.filter(
                                    item => item.tipo === 'Processos Judiciais'
                                );
                                let tempObj = {
                                    data: item.data,
                                    idTemporario: item.idTemporario,
                                    detalhes: {
                                        geral: geral,
                                        processosJudiciais: processosJudiciais
                                    },
                                    totalConsultasDia: item.totalConsultasData,
                                    totalCreditoConsumidoDia:
                                        item.detalhes.reduce(
                                            (total, detalhe) =>
                                                total +
                                                detalhe.creditoConsumido,
                                            0
                                        )
                                };
                                dadosTabela.push(tempObj);
                            });
                        } else {
                            dadosTabela = [];
                        }

                        this.resultadoExtratoConsulta = {
                            totalConsultas,
                            totalConsultasNoMes,
                            totalCreditoConsumidoMes,
                            primeiroRegistro,
                            dadosTabela
                        };

                        this.isLoadingModalExtrato = false;
                    })
                    .catch(() => {
                        this.isLoadingModalExtrato = false;
                        this.$notify.warning({
                            message: this.$t(
                                'mensagens.preAnaliseCredito.erro.obterHistoricoDeBusca'
                            )
                        });
                    });
            } catch (error) {
                this.isLoadingModalExtrato = false;
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.preAnaliseCredito.erro.obterHistoricoDeBusca'
                    )
                });
            }
        },

        async mudarTipoConsulta(tipoConsultaExtrato) {
            this.isLoadingModalExtrato = true;
            this.tipoConsultaExtrato = tipoConsultaExtrato;
            await this.visualizarTotalizadorConsultasNeoway();
        },

        async mudarMesVigenteConsulta(mesVigente) {
            this.isLoadingModalExtrato = true;
            this.mesVigenteConsultaExtrato = mesVigente;
            await this.visualizarTotalizadorConsultasNeoway();
        },

        tratarDataRequest(inputString) {
            const [month, year] = inputString.split('/');
            const date = new Date(`${month}/10/${year}`);
            const formattedDate = `${
                date.getMonth() + 1
            }/${date.getDate()}/${date.getFullYear()}`;

            return formattedDate;
        }
    }
};
</script>

<style lang="scss">
#pre-analise-credito {
    .alert-box {
        display: flex;
    }

    .no-break {
        word-break: keep-all;
    }

    .bold-text {
        font-weight: 600;
        color: black;
    }

    .alert-icon {
        background-color: rgba(230, 162, 60, 1);
        color: white;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 8px;
        flex-shrink: 0;
    }

    header .acoes {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .pre-analise-credito-container {
        display: flex;
        justify-content: space-between;
        height: 48px;
        border-radius: 5px;
        margin-top: 13px;
    }

    .pre-analise-credito-input-container {
        width: 86%;
        height: 48px;
        border-radius: 5px;
        background: var(--white);
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        position: relative;
        margin-right: 10px;
    }

    .pre-analise-creditoinput {
        height: 100%;
        display: flex;
        justify-content: center;

        i.el-icon-search {
            color: var(--primary);
            font-size: 25px;
            font-weight: bold;
            display: flex;
            align-items: center;
            margin: 0 8px;
        }

        .lista-pre-analise-creditobarra-pesquisainput {
            width: 100%;
            height: 100%;
            border: none;
            outline: none;
            border-radius: 5px;

            input {
                border: none;
                outline: none;
                color: var(--primary);
            }

            .el-input--suffix .el-input__inner {
                color: var(--primary);
                width: 100%;
                margin-top: 5px;
            }
        }

        .lista-pre-analise-creditobarra-pesquisainput-erro {
            width: 100%;
            height: 100%;
            border: none;
            outline: none;
            border-radius: 5px;

            input {
                border: none;
                outline: none;
                color: var(--danger);
            }

            .el-input--suffix .el-input__inner {
                color: var(--danger);
                width: 100%;
                margin-top: 5px;
            }
        }
    }

    .invalido {
        color: var(--danger);
    }

    .pre-analise-credito__pesquisa-button {
        width: 14%;

        .pre-analise-credito__btn-pesquisa {
            width: 100%;
            height: 48px;
        }
    }

    .pagination {
        background-color: var(--white);
        border-radius: 0 0 2px 2px;
        justify-content: center;
    }

    .tabela {
        border-radius: 5px;
        overflow: hidden;
        background-color: var(--white);
        height: calc(100vh - 335px);
        width: 100%;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        margin-top: 10px;

        .acoes:hover {
            cursor: pointer;
        }

        tr.el-table__row--striped td.el-table__cell {
            background-color: #f3f3f3;
        }
    }

    .tabela-pesquisa-sem-resultado {
        border-radius: 5px;
        overflow: hidden;
        background-color: var(--white);
        width: 100%;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        margin-top: 10px;
    }

    .show-error-busca {
        background-color: #fef0f0;
        color: #f56c6c;
        margin-top: 10px;
        display: block !important;
    }

    .hide-error-busca {
        background-color: #fef0f0;
        color: #f56c6c;
        margin-top: 10px;
        display: none !important;
    }
}
</style>
